module.exports = __webpack_public_path__ + "img/spryker.cccbc1ea.png";